<script setup>
import { ref, onMounted, onUnmounted } from 'vue';
import { Html5Qrcode } from 'html5-qrcode';
import { useRouter } from 'vue-router';
import { getBiboMerchantDetails } from '@/api/matchinpay';
import { ecShopAdvisoryVisibility } from '@/api/common';
import { getCurrentUser } from '../../utils/index';
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";

const router = useRouter();
const qrCodeResult = ref("");
const qrBranchName = ref("");
const qrMarchantCode = ref("");
const qrAccountNumber = ref("");
const errorMessage = ref("");
const matchinpayLogo = ref("");
const logoStyle = ref({});
const logoClass = ref("");
const current_usid = ref("");
const isOverriden = ref(false);
const ccode = ref(-1);
const isGettingBiboMerchantDetails = ref(true);
const isValidQRCode = ref(false);
const continueScanning = ref(true);

let html5QrCode = null;

const getBiboMerchantDetailsLocal = async (qr) => {
  let params = { qrcode: qr };

  if (isGettingBiboMerchantDetails.value) {
    const response = await getBiboMerchantDetails(params);

    if (response.data) {
      isGettingBiboMerchantDetails.value = false;

      if (response.data.result === "FAILED") {
        isValidQRCode.value = false;
        qrCodeResult.value = "";
        qrBranchName.value = "";
        qrMarchantCode.value = "";
        errorMessage.value = response.data.message;
        console.log(response.data.message);
        stopScanning();

        setTimeout(() => {
          continueScanning.value = true;
          errorMessage.value = "";
          startScanning();
        }, 500);
      } else {
        qrBranchName.value = response.data.biboMerchantDetails.branchName;
        qrMarchantCode.value = response.data.biboMerchantDetails.merchantCode;
        qrAccountNumber.value = response.data.biboAccountno;

        console.log(qrBranchName.value);
        console.log(qrMarchantCode.value);
        console.log(qrAccountNumber.value);

        isValidQRCode.value = true;
        continueScanning.value = false;
        stopScanning();
        goToPaymentPage();
      }
    } else {
      isValidQRCode.value = false;
      errorMessage.value = "Invalid QR Code.";

      setTimeout(() => {
        continueScanning.value = true;
        startScanning();
      }, 500);
    }
  }
};

const startScanning = () => {
  const config = { fps: 10, qrbox: 250 };
  html5QrCode = new Html5Qrcode("reader");

  Html5Qrcode.getCameras().then(devices => {
    if (devices && devices.length) {
      // Try to find a back camera
      const backCamera = devices.find(device =>
        device.label.toLowerCase().includes("back") ||
        device.label.toLowerCase().includes("environment")
      );

      const selectedCameraId = backCamera ? backCamera.id : devices[0].id;

      html5QrCode.start(
        selectedCameraId,
        config,
        qrCodeMessage => {
          
          if (continueScanning.value && qrCodeMessage) {
            qrCodeResult.value = qrCodeMessage;
            console.log(qrCodeResult.value);
            isGettingBiboMerchantDetails.value = true;
            getBiboMerchantDetailsLocal(qrCodeMessage);
          }
        },
        errorMessage => {
          // optional error callback
         
        }
      ).catch(err => {
        errorMessage.value = "QR scanning failed to start.";
        console.error("Start error", err);
      });
    }
  }).catch(err => {
    errorMessage.value = "Camera access error.";
    console.error("Camera error", err);
  });
};

const stopScanning = () => {
  if (html5QrCode) {
    html5QrCode.stop()
    .then(() => html5QrCode.clear())
    .catch(err => console.error("Stop error", err));
}
};

const goToPaymentPage = () => {
  router.push({ name: "mgpaypaymentpage", params: { qrBranchName: qrBranchName.value, qrMerchantCode: qrMarchantCode.value, qrAccountNumber : qrAccountNumber.value } });
};

const onResize = () => {
  const width = window.innerWidth;
  if (width <= 450) {
    matchinpayLogo.value = "https://images.empoweredconsumerism-static-files.com/ecp/MG_PAY_PC.png";
    logoStyle.value = { width: "100px", height: "auto" };
    logoClass.value = "col-xxl-12 mb-5 text-center";
  } else {
    matchinpayLogo.value = "https://images.empoweredconsumerism-static-files.com/ecp/MG_PAY_PC.png";
    logoStyle.value = { width: "300px", height: "auto" };
    logoClass.value = "col-xxl-12 mb-5 text-center";
  }
};

onMounted(() => {
  setCurrentPageTitle("MG Pay QR Code Scanner");
  const currentUser = getCurrentUser();
  const overrideCifId = localStorage.getItem('override_cifid');

  if (currentUser) current_usid.value = currentUser.usid;
  if (overrideCifId !== null) isOverriden.value = true;

  ccode.value = Number(localStorage.getItem("ccode"));

  if (ccode.value === 0 && !isOverriden.value) {
    hideECShopAdvisory();
    startScanning();
    onResize();
  } else {
    router.push({ name: "estore" });
  }
});

//onUnmounted(() => stopScanning());

const hideECShopAdvisory = () => {
  ecShopAdvisoryVisibility.hide();
};

const showECShopAdvisory = () => {
  ecShopAdvisoryVisibility.show();
};



</script>

<style>
.scanner-frame {
  position: relative;
  width: 100%;
  max-width: 400px;
  height: 350px;
  margin: auto;
}
.scanner-video {
  width: 100%;
  /*height: 100%;*/
  object-fit: cover;
}

.error-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 229, 229, 0.8);
  color: #c82626;
  font-weight: bold;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 20px;
  box-sizing: border-box;
  z-index: 10;
  pointer-events: none;
}
</style>

<template>
  <div :class="logoClass">
    <img :src="matchinpayLogo" :style="logoStyle" />
  </div>
  <div class="row fs-3 fw-bolder text-center">
    <p>Please scan a QR code.</p>
  </div>
  <div class="scanner-frame">
    <div id="reader" class="scanner-video"></div>
    <div v-if="errorMessage" class="error-overlay">
      {{ errorMessage }}
    </div>
  </div>
</template>